(function () {
    "use strict";

    angular
        .module("app")
        .component("certificates", { // certificates
            templateUrl: "src/app/certificates/certificates.html",
            controller: controller
        });

    function controller($q, session, FileUploader, utils, toast) {
        const $ctrl = this;
        const token = utils.token();
        $ctrl.session = session;

        $ctrl.uploadingCert = false;
        $ctrl.certificatePassword = "";
        $ctrl.certificateDeaNumber = "";
        $ctrl.errors = [];
        $ctrl.warnings = [];
        $ctrl.infos = [];

        $ctrl.uploader = new FileUploader({
            url: "/api/csos-certificates",
            queueLimit: 1,
            removeAfterUpload: false,
            withCredentials: false,
            headers: {
                "Authorization": token
            }
        });

        $ctrl.deleteCert = cert => {
            session.certificates
                .deleteCertificate(cert.certificate_id)
                .then(response => {
                    const index = session.certificates.certificates.findIndex(c => c.certificate_id === cert.certificate_id);
                    if (index !== -1)
                        session.certificates.certificates.splice(index, 1);
                    toast.success("Delete Certificate", "Certificate has been deleted.");
                });
        };



        $ctrl.canUpload = () => {
            return $ctrl.uploader.queue.length &&
                $ctrl.certificatePassword.length &&
                $ctrl.certificateDeaNumber.length;
        };

        // Have to do this to set properties other than the init of FileUploader. derrrrrp
        $ctrl.uploader.onBeforeUploadItem = function (item) {
            item.formData.push({ "certificatePassword": $ctrl.certificatePassword });
            item.formData.push({ "certificateDeaNumber": $ctrl.certificateDeaNumber });
        }

        // Have to do this to replace the item in the picker. derrrrrrp.
        $ctrl.uploader.onWhenAddingFileFailed = function (item, filter, options) {
            if (filter.name == "queueLimit") {
                $ctrl.uploader.clearQueue();
                $ctrl.uploader.addToQueue(item);
            }
        }

        $ctrl.upload = () => {
            $ctrl.errors = [];
            $ctrl.uploadingCert = true;

            // Have to reset these to send the same file again. derrrrrrp.
            const item = $ctrl.uploader.queue[0];
            item.isSuccess = false;
            item.isUploaded = false;
            item.formData = [];
            $ctrl.uploader.uploadAll();
        };

        $ctrl.uploader.onCompleteItem = function (item, response, status, headers) {
            $ctrl.uploadingCert = false;

            if (response.Success === true) {
                const scr = response.SaveCertificateResult;
                const existing = session.certificates.certificates.find(c => c.certificate_id === scr.CertificateId);

                if (!existing) {
                    session.certificates.certificates.push({
                        certificate_id: scr.CertificateId,
                        cert_hash: scr.CertificateHash,
                        customer_id: session.customer.company_id,
                        contact_dea: $ctrl.certificateDeaNumber,
                        upload_user_id: "",
                        friendly_name: scr.FriendlyName,
                        cert_issued_to: scr.IssuedTo,
                        valid_from_date: scr.ValidFromDate,
                        valid_to_date: scr.ExpirationDate,
                        the_cert: null,
                        public_key_XML: scr.PublicKeyXmlString,
                        key_usage: scr.KeyUsage,
                        issued_by: scr.IssuedBy,
                        is_deleted: "N",
                        create_date: null,
                        create_user: null
                    });
                }

                document.getElementById("fileInput").value = null;
                $ctrl.uploader.clearQueue();
                $ctrl.certificatePassword = "";
                $ctrl.certificateDeaNumber = "";

                if (!!scr.AlreadyExists)
                    toast.success("Upload Certificate", "Certificate already exists.");
                else
                    toast.success("Upload Certificate", "Certificate has been uploaded.");

            } else {
                console.log("Failed to upload certificate.", response);
                if (response.InvalidPassword) { $ctrl.errors.push("Invalid Password"); return; }

                if (response.SaveCertificateResult) {
                    const scr = response.SaveCertificateResult;

                    if (scr.ValidateCertificateResult) {
                        const vcr = scr.ValidateCertificateResult;

                        // Warning
                        if (!!vcr.LdapNotAvailable) $ctrl.warnings.push("Failed to contact the DEA LDAP server. Please try again later.");

                        // Errors
                        if (!!vcr.DeaNumberNotValid) { $ctrl.errors.push("DEA Number is not correct.");  }
                        if (!!vcr.Expired) { $ctrl.errors.push("The certificate is Expired.");  }
                        if (!!vcr.PrivateKeyMissing) { $ctrl.errors.push("The certificate is missing the private key.");  }
                        if (!!vcr.Revoked) { $ctrl.errors.push("The certificate has been revoked.");  }
                        if (!!vcr.ChainNotValid) { $ctrl.errors.push("The certificate is not a valid certificate for CSOS (Certificate chain not valid).");  }
                    }
                }
                if (!$ctrl.errors.length && !$ctrl.warnings.length && !$ctrl.infos.length)
                    $ctrl.warnings.push("Failed to upload certificate. Please refresh the page and try again.");
            }
        }
    }
    controller.$inject = ["$q", "sessionService", "FileUploader", "stUtilsFactory", "stToastFactory"];

})()